import Landing from "@/components/Landing";
import AboutMe from "@/components/AboutMe";
import Skills from "@/components/Skills";
import Projects from "@/components/Projects";
import ProfessionalExperience from "@/components/ProfessionalExperience";
import AdditionalExperiences from "@/components/AdditionalExperiences";
import Recommendations from "@/components/Recommendations";
import Education from "@/components/Education";
import Certificates from "@/components/Certificates";
import Blogs from "@/components/Blogs";
import Contact from "@/components/Contact";
import { useSEO } from "@/hooks/use-seo";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";

const Index = () => {
  const seo = useSEO({
    title: "Shishir Regmi | .NET Developer & Software Engineer",
    description:
      "Portfolio of Shishir Regmi, a .NET developer specializing in ASP.NET Core, C#, APIs, databases, and scalable backend software.",
    url: "/",
  });

  useScrollReveal({ once: true });
  return (
    <div className="min-h-screen">
      {seo}
      <Landing />
      <section id="about" data-reveal data-reveal-delay="0.05s">
        <AboutMe />
      </section>
      <section id="experience" data-reveal data-reveal-delay="0.1s">
        <ProfessionalExperience />
      </section>
      <section id="additional-experience" data-reveal data-reveal-delay="0.13s">
        <AdditionalExperiences showViewMore />
      </section>
      <section
        id="education"
        data-reveal
        data-reveal-delay="0.15s"
        className="space-y-12"
      >
        <Education />
        <Certificates />
        <Skills />
      </section>
      <section id="recommendations" data-reveal data-reveal-delay="0.23s">
        <Recommendations />
      </section>
      <section id="blogs" data-reveal data-reveal-delay="0.27s">
        <Blogs />
      </section>
      <section id="projects" data-reveal data-reveal-delay="0.3s">
        <Projects />
      </section>
      <section id="contact" data-reveal data-reveal-delay="0.35s">
        <div className="container max-w-6xl mx-auto py-20 px-6">
          <Contact />
        </div>
      </section>
    </div>
  );
};

export default Index;
